import { createSlice } from "@reduxjs/toolkit";

const itemSlice = createSlice({
    name: 'item',
    initialState: {
        listaItem: [],
    },
    reducers: {
        addItem: (state, action) => {
            state.listaItem = action.payload
        },
    }
});

export const { addItem } = itemSlice.actions;
export default itemSlice.reducer;